import { Menu, MenuItem } from "@mui/material";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { AccountMenuProps } from "layout/primarylayout/AccountMenu";
import { useState } from "react";
import EditCategory from "./EditCategory";
import { deleteCategory } from "api/services/categories";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import EditSubCategory from "./EditSubCategory";
import { deleteSubCategory } from "api/services/categories";

interface EditCategoryPopoverProps extends AccountMenuProps {
  data: any;
  selectedSubCategory: any;
}

function EditSubCategoryPopover(props: EditCategoryPopoverProps) {
  const { anchorEl, setAnchorEl, data, selectedSubCategory } = props;
  const [editSubCategoryOpen, setEditSubCategoryOpen] = useState<boolean>(false);
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();
  const confirm = useConfirm();

  const handleEdit = () => {
    setEditSubCategoryOpen(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { mutate, isLoading: deleteLoading } = useMutation(deleteSubCategory, {
    onSuccess: () => {
      snack.success("Sub Category Deleted");
      queryClient.invalidateQueries("categories");
      setAnchorEl(null);
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleDelete = () => {
    confirm({
      msg: "Are you sure you want to delete this Sub Category?",
      action: () => mutate({ id: selectedSubCategory?.id }),
    });
  };

  return (
    <>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: 100,
          },
        }}
      >
        <ValidateAccess name={Permissions.DELETE_CATEGORIES}>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </ValidateAccess>
      </Menu>
    </>
  );
}

export default EditSubCategoryPopover;
